import React from "react";
import Header from "./components/PublicDocsNavbar";
import Content from "./components/PrivacyPolicy";
import Footer from "./components/PublicDocsFooter";

function PrivacyPolicy() {
  return (
    <div className="wrap-ppolicy">
      <Header />
      <Content />
      <Footer />
    </div>
  );
}

export default PrivacyPolicy;
